import { combineReducers } from '@reduxjs/toolkit';
import { DefaultState, createFetchReducer } from 'store/setLocalStore';
import session, { EVisitInsuranceSessionState } from './eVisitSession';
import insurance, { EVisitInsuranceState } from './eVisitInsurance';
import * as actions from '../actions';

export interface EVisitState {
  eligibility: DefaultState<{ access: boolean }>;
  insurance: EVisitInsuranceState;
  session: EVisitInsuranceSessionState;
}

export default combineReducers({
  session,
  insurance,
  eligibility: createFetchReducer(actions.CHECK_E_VISIT_ELIGIBILITY, true)
});
